import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { useCart } from './CartContext';
import './rice.css';

const products = [
    { name: 'Ragi Flour', image: '/images/flours/ragi.webp', link: '/flours/ragi' },
    { name: 'Idiyappam Flour', image: '/images/flours/idiyapam.webp', link: '/flours/idiyappam' },
    { name: 'Puttu Flour', image: '/images/flours/puttu.webp', link: '/flours/puttu' },
    { name: 'Samba Puttu Flour', image: '/images/flours/samba.webp', link: '/flours/sambaputtu' },
    { name: 'Kozhakkattai Flour', image: '/images/flours/kozhakattai.png', link: '/flours/kozhakkattai' },
    { name: 'Murukku Flour', image: '/images/flours/muruku.webp', link: '/flours/murukku' },
    { name: 'Pearl  Millet Flour', image: '/images/flours/pearl.webp', link: '/flours/pearlmillet' },
    { name: 'Besan Flour', image: '/images/flours/besan.webp', link: '/flours/besan' },

];

const qtyOptions = ['500g', '1kg', '2kg', '10kg', '25kg'];

const Flours = () => {
    const navigate = useNavigate();
    const { addToCart } = useCart();
    const [selectedQuantities, setSelectedQuantities] = useState({});

    const handleKnowMore = (link) => {
        navigate(link);
    };
    const goToProducts = () => {
        navigate('/products');
    };
    const toggleQtyType = (productIndex, qtyType) => {
        const productQuantities = selectedQuantities[productIndex] || {};
        const isSelected = qtyType in productQuantities;

        const updated = { ...productQuantities };
        if (isSelected) {
            delete updated[qtyType];
        } else {
            updated[qtyType] = 1;
        }

        setSelectedQuantities({
            ...selectedQuantities,
            [productIndex]: updated,
        });
    };

    const incrementQty = (index, qtyType) => {
        const productQuantities = selectedQuantities[index] || {};
        const currentQty = productQuantities[qtyType] || 1;

        setSelectedQuantities({
            ...selectedQuantities,
            [index]: {
                ...productQuantities,
                [qtyType]: currentQty + 1,
            },
        });
    };

    const decrementQty = (index, qtyType) => {
        const productQuantities = selectedQuantities[index] || {};
        const currentQty = productQuantities[qtyType];

        if (currentQty > 1) {
            setSelectedQuantities({
                ...selectedQuantities,
                [index]: {
                    ...productQuantities,
                    [qtyType]: currentQty - 1,
                },
            });
        }
    };

    const handleAddToCart = (product, index) => {
        const quantities = selectedQuantities[index];
        if (!quantities || Object.keys(quantities).length === 0) {
            toast.warn("Please select at least one quantity!", { position: "top-right" });
            return;
        }

        Object.entries(quantities).forEach(([qtyType, qtyCount]) => {
            const item = {
                ...product,
                qtyType,
                qtyCount,
            };
            addToCart(item);
            toast.success(`${product.name} (${qtyCount} × ${qtyType}) added to cart`, {
                position: "top-right",
                autoClose: 2000,
            });
        });
    };

    return (
        <section className="rice">
            <div className='border'>
                <img src="/images/border.png" className='border-img' alt="decorative border" />
            </div>
            <h1>Jeyam Flours</h1>
            <div className='border'>
                <img src="/images/border.png" className='border-img' alt="decorative border" />
            </div>
            <button className='back-btn' onClick={goToProducts}>⟵ Back to Products</button>
            <div className="product-grid">
                {products.map((product, index) => (
                    <div className="product-card" key={index}>
                        <img src={product.image} alt={product.name} />
                        <div className="product-name">{product.name}</div>
                        <div className="qty-options">
                            {qtyOptions.map((qtyType) => {
                                const isSelected = selectedQuantities[index]?.[qtyType];

                                return (
                                    <div key={qtyType} className="qty-select-block">
                                        <span
                                            className={isSelected ? 'qty selected' : 'qty'}
                                            onClick={() => toggleQtyType(index, qtyType)}
                                        >
                                            {qtyType}
                                        </span>
                                        {isSelected && (
                                            <div className="qty-controls">
                                                <button onClick={() => decrementQty(index, qtyType)}>-</button>
                                                <span>{selectedQuantities[index][qtyType]}</span>
                                                <button onClick={() => incrementQty(index, qtyType)}>+</button>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>

                        <div className="btn-group">
                            <button className="know-more" onClick={() => handleKnowMore(product.link)}>
                                Know More
                            </button>
                            <button className="add-cart" onClick={() => handleAddToCart(product, index)}>
                                Add to Cart
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            <div className='cart-button'>
                <Link to="/cart">
                    <button className='cart-btn'>Go To Cart</button>
                </Link>
            </div>
            <Link to="/cart" className="floating-cart-btn" title="Go to Cart">
                Go to cart 🛒
            </Link>

            <ToastContainer />

        </section>
    );
};

export default Flours;
